import { instance } from './axios'
import qs from 'qs'
import { propTradingUrl, depositUrlV2 } from './index'

// refactor: extract to utils
function queryStringBuilder(data = {}) {
  const qs = []
  for (const [k, v] of Object.entries(data)) {
    if (v || Number.isInteger(v)) qs.push(`${k}=${v}`)
  }

  const result = qs.filter(Boolean).join('&')

  return `${result ? '?' : ''}${result}`
}

/** propTrading */
export const apiPropTradingSettings = data => instance.get(`${propTradingUrl}settings`)

export const apiPropTradingProceedPayment = (data, token) =>
  instance.post(`${propTradingUrl}proceedPayment`, data, { headers: { token: token } })
export const apiPropTradingProceedPaymentCPS = (data, token) =>
  instance.post(`${propTradingUrl}proceedPaymentCPS`, data, { headers: { token: token } })

export const apiGetDashBoardAccountList = (accountStatus, accountStage) => {
  return instance.get(`${propTradingUrl}getDashBoardAccountList${queryStringBuilder({ accountStatus, accountStage })}`)
}
export const apiGetDashBoardSessionList = sessionStatus => {
  return instance.get(`${propTradingUrl}getDashBoardSessionList${queryStringBuilder({ sessionStatus })}`)
}

export const apiGetAccountMetrics = accountNumber =>
  instance.get(`${propTradingUrl}getAccountMetrics?accountNumber=${accountNumber}`)

export const apiEligiblePropTrading = () => instance.get(`${propTradingUrl}eligible-propTrading`)

export const apiUpdateAccountIsNew = data =>
  instance.post(`${propTradingUrl}updateAccountIsNew${queryStringBuilder(data)}`)

export const apiResetPassword = data => instance.post(`${propTradingUrl}resetPassword`, data)

export const apiForgetPassword = data => instance.post(`${propTradingUrl}forgetPassword`, data)
export const apiResetPasswordByToken = data => instance.post(`${propTradingUrl}resetPasswordByToken`, data)

export const apiCheckPromoAvailable = (feeSettingId = '', promoCode = '') =>
  instance.get(`${propTradingUrl}checkPromoAvailable?feeSettingId=${feeSettingId}&promoCode=${promoCode}`)

export const apiGetSessionHistory = sessionId =>
  instance.get(`${propTradingUrl}getSessionHistory?sessionId=${sessionId}`)

export const apiGetServerTime = () => instance.get(`${systemUrl}getServerTime`)

export const apiGetCertificationPDFList = () => instance.get(`${propTradingUrl}getCertificationPDFList`)
export const apiDownloadCertificationPDF = (sessionNumber, accountStage) =>
  instance.get(
    `${propTradingUrl}/downloadCertificationPDF?sessionNumber=${sessionNumber}&accountStage=${accountStage}`,
    { responseType: 'blob' }
  )

export const apiGetAccountGraph = accountNumber =>
  instance.get(`${propTradingUrl}getAccountGraph?accountNumber=${accountNumber}`)
export const apiPayoutInfo = (accountNumber, paymentType) =>
  instance.get(`${propTradingUrl}pay-out/info?accountNumber=${accountNumber}&paymentType=${paymentType}`)
export const apiPropTradingPayout = (data, token) =>
  instance.post(`${propTradingUrl}pay-out/all`, data, { headers: { token: token } })
export const apiPtGetNonCreditCardWithdrawTypeCP = data =>
  instance.post(`${propTradingUrl}pay-out/getNonCreditCardWithdrawTypeCP`, data)

export const apiAvailableChannel = () => instance.get(`${depositUrlV2}availableChannel`)